import { DateTime } from "luxon";
import { Just, Nothing, Maybe } from "purify-ts";

export interface DateParseConfig {
  value: string;
  format: string;
}

export type DateLike =
  | string
  | Date
  | DateTime
  | number
  | null
  | DateParseConfig
  | ((dt: luxon.DateTime) => string);

const valid = (date: DateTime): Maybe<DateTime> => {
  return date.isValid ? Just(date) : Nothing;
};

export const toValidLuxonDateTime = (
  providedDate: DateLike
): Maybe<DateTime> => {
  const date = Maybe.fromFalsy(providedDate)
    .chain((date) => {
      try {
        if (date instanceof DateTime) return valid(date);
        if (date instanceof Date) return valid(DateTime.fromJSDate(date));
        if (typeof date === "object" && "value" in date && "format" in date) {
          return valid(DateTime.fromFormat(date.value, date.format));
        }
        if (typeof date === "string") return valid(DateTime.fromISO(date));
        if (typeof date === "number") return valid(DateTime.fromMillis(date));
        return Nothing;
      } catch (e) {
        return Nothing;
      }
    })
    .map((c) => (c.isValid ? c : null));
  return date;
};
